import { render } from "./Home.vue?vue&type=template&id=6328009a&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=6328009a&lang=scss&scoped=true"

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6328009a"]])

export default __exports__